jQuery(document).ready(function($){
    // Existing toggle logic for the button text
    $(".read-toggle").on("toggle", function () {
        var details = this;
        var $summary = $(this).find("summary");
        if (details.open) {
            $summary.text("READ LESS");
        } else {
            $summary.text("READ MORE");
        }
    });

    // Toggle on click anywhere in the card
    $(".professional-journey-card").on("click", function(e) {
        var $details = $(this).find(".read-toggle");
        if ($details.length === 0) return;

        var details = $details[0];

        // If the user clicked on the summary itself or any link/button inside, let the default behavior happen
        if ($(e.target).closest('summary').length || $(e.target).closest('a, button').length) {
            return;
        }
        
        e.preventDefault();
        details.open = !details.open;
    });
});

// Intersection Observer for culture-pillars gradient animation on mobile
document.addEventListener('DOMContentLoaded', function() {
    const culturePillars = document.querySelector('.culture-pillars');
    
    if (culturePillars && window.innerWidth <= 991) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                    // Stop observing once the animation has been triggered
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1, // Trigger when 10% of the element is visible
            rootMargin: '50px 0px', // Start trigger 50px before element enters viewport
        });

        observer.observe(culturePillars);
        
        // If element is already in view on page load, trigger immediately
        const rect = culturePillars.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight && rect.bottom > 0;
        if (isInView) {
            culturePillars.classList.add('in-view');
        }
    }
});
